import { PriceRow } from 'components/Product/ProductPrice';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { Language, Product } from 'types/schema';
import formatMoney from '../../../utils/formatMoney';

export const PriceText = styled.p`
  color: #595959;
  font-size: 16px;
  font-weight: 700;
`;

export interface PriceProps {
  style?: CSSProperties;
  product: Product;
  baseUom?: string;
  baseUomPrice?: number;
  netUom?: string;
  lang?: Language;
}

const PriceContainer = styled.div`
  height: 40px;
`;

const DiscountPrice = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #595959;
`;
const PerPrice = styled.p`
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  color: #808289;
`;
const BasePrice = styled.p`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #aaacb2;
  text-decoration: line-through;
`;

export const Price = ({ product, baseUomPrice, baseUom, netUom }: PriceProps) => {
  const { price, originalPrice, baseUnit, netUnit, netUomPrice } = product;

  return (
    <PriceContainer>
      <PriceRow>
        <DiscountPrice>
          {formatMoney(price)}
          <span style={{ fontSize: 14 }}>đ</span>
        </DiscountPrice>
        {originalPrice > price ? <BasePrice>{formatMoney(originalPrice)}đ</BasePrice> : null}
      </PriceRow>

      {baseUnit === 1 && netUnit !== 1 && netUomPrice && netUom ? (
        <PerPrice>
          ({formatMoney(netUomPrice)}đ/{netUom})
        </PerPrice>
      ) : baseUomPrice && (netUnit !== 1 || baseUnit !== 1) ? (
        <PerPrice>
          ({formatMoney(baseUomPrice)}đ{baseUom ? `/${baseUom}` : ''})
        </PerPrice>
      ) : null}
    </PriceContainer>
  );
};
